import {
  UserPlus,
  BookOpen,
  ClipboardCheck,
  FolderGit2,
  Briefcase,
  GraduationCap,
  Rocket,
} from "lucide-react";

function LearningJourney() {
  const steps = [
    {
      icon: <UserPlus size={32} />,
      title: "Enroll",
      desc: "Choose your preferred course and complete your enrollment.",
    },
    {
      icon: <BookOpen size={32} />,
      title: "Learn",
      desc: "Attend interactive classes and understand concepts step by step.",
    },
    {
      icon: <ClipboardCheck size={32} />,
      title: "Assignments",
      desc: "Practice regularly with practical assignments and exercises.",
    },
    {
      icon: <FolderGit2 size={32} />,
      title: "Projects",
      desc: "Build real-world projects using industry-standard tools.",
    },
    {
      icon: <Briefcase size={32} />,
      title: "Portfolio",
      desc: "Create a professional portfolio showcasing your skills.",
    },
    {
      icon: <GraduationCap size={32} />,
      title: "Career Support",
      desc: "Resume building, interview preparation, and mentorship.",
    },
    {
      icon: <Rocket size={32} />,
      title: "Success",
      desc: "Start your career, freelancing journey, or business confidently.",
    },
  ];

  return (
    <section
      id="journey"
      className="py-24 bg-gradient-to-b from-blue-50 to-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">

        {/* Heading */}

        <div className="text-center mb-16">
          <span className="bg-blue-100 text-blue-700 px-5 py-2 rounded-full font-semibold">
            Learning Journey
          </span>

          <h2 className="text-4xl lg:text-5xl font-bold mt-6">
            Your Journey to a
            <span className="text-blue-700"> Successful Career</span>
          </h2>

          <p className="mt-5 text-gray-600 max-w-3xl mx-auto leading-8">
            Follow our structured learning path designed to transform beginners
            into skilled digital professionals.
          </p>
        </div>

        {/* Timeline */}

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">

          {steps.map((step, index) => (
            <div
              key={index}
              className="relative bg-white rounded-3xl shadow-lg p-8 text-center hover:-translate-y-3 hover:shadow-2xl transition duration-300"
            >
              <div className="w-16 h-16 mx-auto rounded-full bg-blue-600 text-white flex items-center justify-center">
                {step.icon}
              </div>

              <div className="mt-6">

                <span className="inline-block bg-blue-100 text-blue-700 text-sm font-bold px-3 py-1 rounded-full">
                  Step {index + 1}
                </span>

                <h3 className="text-2xl font-bold mt-4 text-gray-900">
                  {step.title}
                </h3>

                <p className="mt-4 text-gray-600 leading-7">
                  {step.desc}
                </p>

              </div>
            </div>
          ))}

        </div>
      </div>
    </section>
  );
}

export default LearningJourney;